import React, { useState } from "react";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { Link } from "react-router-dom";
import contactAPI from "../../api/contactApi";
import { showSuccess, showError } from "../../utils/toastUtils";
import useAlphabetsInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";
import Breadcrump from "../../components/Breadcrump";
import { Container, Row, Col, Form } from "react-bootstrap";
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTwitter, 
  FaYoutube, 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt 
} from "react-icons/fa";

function ContactUs() {
  useAlphabetsInput();
  useNumericInput();
  const { config } = useSiteConfig();

  const INITAL_FORM_DATA = { email: "", phone: "", name: "", message: "" };
  const [formData, setFormData] = useState(INITAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone is required";
    if (!formData.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const res = await contactAPI.store(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <Breadcrump title="Get In Touch" />

      <div className="contact-page-funky">
        <Container className="py-5">
          <Row className="g-5 align-items-stretch">
            
            {/* Left Side: Info Panel */}
            <Col lg={5}>
              <div className="info-panel-funky">
                <span className="badge-text mb-3">CONTACT US</span>
                <h2 className="panel-title mb-4">Let's Talk About Your Cravings!</h2>
                
                <div className="contact-details-list">
                  <div className="detail-item">
                    <div className="icon-box"><FaWhatsapp /></div>
                    <div className="text-box">
                      <h6>WhatsApp Us</h6>
                      <a href={`https://wa.me/${config?.whatsappNumber}`} target="_blank">+91 {config?.whatsappNumber}</a>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="icon-box"><FaEnvelope /></div>
                    <div className="text-box">
                      <h6>Email Support</h6>
                      <a href={`mailto:${config?.email}`}>{config?.email}</a>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="icon-box"><FaMapMarkerAlt /></div>
                    <div className="text-box">
                      <h6>Our Base</h6>
                      <p>{config?.address?.addressLine}, {config?.address?.district}, {config?.address?.state}</p>
                    </div>
                  </div>
                </div>

                <div className="social-footer-funky">
                  <h6>Follow the Vibe:</h6>
                  <div className="social-links-grid">
                    {config?.socialMedia?.instagram && <a href={config.socialMedia.instagram} target="_blank" className="s-link"><FaInstagram /></a>}
                    {config?.socialMedia?.facebook && <a href={config.socialMedia.facebook} target="_blank" className="s-link"><FaFacebookF /></a>}
                    {config?.socialMedia?.twitter && <a href={config.socialMedia.twitter} target="_blank" className="s-link"><FaTwitter /></a>}
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Side: Form Panel */}
            <Col lg={7}>
              <div className="form-panel-funky">
                <Form onSubmit={handleSubmit}>
                  <Row className="g-4">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="funky-label">Full Name</Form.Label>
                        <Form.Control 
                          name="name" 
                          value={formData.name} 
                          onChange={handleChange} 
                          className="funky-input only-alphabets" 
                          placeholder="Your Good Name"
                        />
                        {errors.name && <small className="text-danger">{errors.name}</small>}
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="funky-label">Email Address</Form.Label>
                        <Form.Control 
                          type="email" 
                          name="email" 
                          value={formData.email} 
                          onChange={handleChange} 
                          className="funky-input" 
                          placeholder="hello@vibe.com"
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="funky-label">Phone Number</Form.Label>
                        <Form.Control 
                          maxLength={10} 
                          name="phone" 
                          value={formData.phone} 
                          onChange={handleChange} 
                          className="funky-input only-numeric" 
                          placeholder="10 Digit Number"
                        />
                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="funky-label">Your Message</Form.Label>
                        <Form.Control 
                          as="textarea" 
                          rows={4} 
                          name="message" 
                          value={formData.message} 
                          onChange={handleChange} 
                          className="funky-input" 
                          placeholder="What's on your mind?"
                        />
                        {errors.message && <small className="text-danger">{errors.message}</small>}
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <button type="submit" className="funky-submit-btn">
                        SEND MESSAGE ⚡
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>

        {config?.address?.mapLocation && (
          <div className="map-wrapper-funky">
            <iframe src={config?.address?.mapLocation} className="map-frame" allowFullScreen loading="lazy" />
          </div>
        )}
      </div>
    </>
  );
}

export default ContactUs;